import gql from "graphql-tag";

export const QUERY_CHECK_REPORT_NUMBER = gql`
  query CheckReportNumber($reportNumber: String) {
    checkReportNumber(reportNumber: $reportNumber)
  }
`;
